
namespace Nobox.CRM {

    @Serenity.Decorators.registerEditor('Nobox.CRM.PickerContactdealsEditor')
    export class PickerContactdealsEditor extends Serenity.Extensions.GridEditorBase<DealcontactsRow> {
        protected getColumnsKey() { return ContactdealClmsColumns.columnsKey; }
        protected getDialogType() { return DealcontactsDialog; }
        protected getLocalTextPrefix() { return DealcontactsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }

        validateEntity(row, id) {
            row.Id = Q.toId(row.Id);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.Id === row.Id);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This product is already in order details!');
                return false;
            }

            //row.ProductName = GroupsRow.getLookup().itemById[row.Id].Nm;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        protected getColumns() {
            var columns = super.getColumns();

            columns.unshift({
                field: 'Remove Attendee',
                name: '',
                format: ctx => '<a class="inline-action delete-grp" title="This group is not permanently deleted before clicking the save & apply changes button.">' +
                    '<i class="fa fa-times text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            //Q.first(columns, x => x.field == fld.CtNm).format =
            //    ctx => `<a href="javascript:;" class="contact-link">${Q.htmlEncode(ctx.value)}</a>`;

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var $this = this;
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('delete-grp')) {
                e.preventDefault();

                var items = this.view.getItems();
                items.splice(row, 1);
                this.setItems(items);
            }
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons[0].visible = false;
            buttons.push({
                title: "Pick Contacts",
                cssClass: "add-button",
                onClick: () => {
                    var dlg = new DealContactPickerDialog({
                        hideProducts: this.view.getItems().map(x => x.CtId)
                    });
                    dlg.onSuccess = (selected) => {
                        // filter already existing products
                        selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.CtId == x.Id));

                        for (var sel of selected) {
                            //Q.reloadLookup(Nobox.LeadRow.lookupKey);
                            //var cont = ContactsRow.getLookup().itemById[sel.Id];
                            var item = <DealcontactsRow>{
                                CtId: sel.Id,
                                CtNm: sel.Name,
                                //CtNo: cont.Phone,
                                //CtEmail: cont.Email
                            };
                            var id = this.getNextId();
                            item[this.getIdProperty()] = id;
                            this.view.addItem(item);
                        }

                        return true;
                    };
                    dlg.dialogOpen();
                }
            });

            return buttons;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            var $this = this;
            Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text, done) => {
                if (text == "") {
                    this.view.setFilter((item, view) => { return true });
                    this.view.refresh();
                    done(true);
                } else {
                    this.view.setFilter((item, view) => { return item.CtNm.toLowerCase().indexOf(text.toLowerCase()) !== -1 });
                    this.view.refresh();
                    done(true);
                }
            });
        }
    }
}